import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_056ca",
  "use": "arrow_056ca-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"arrow_056ca\">\n    <path d=\"M466.998 243.006l-448 447.996C6.329 703.671 0 718.655 0 735.999s6.329 32.339 18.998 45.008c12.669 12.669 27.663 18.998 44.997 18.998h895.996c17.331 0 32.335-6.329 44.997-18.998 12.669-12.683 19.012-27.677 19.012-45.008 0-17.334-6.343-32.328-19.012-44.997l-448-447.996c-12.655-12.658-27.66-19.012-44.997-19.012-17.331 0-32.325 6.35-44.994 19.012z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol